// extracted by mini-css-extract-plugin
export default {"formWrap":"formWrap-wVABj","formWrapBtns":"formWrap-btns-f4Ktu","line":"line-sxjmv"};